// frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import './App.css';
import NavBar from './components/layout/NavBar';
import Footer from './components/layout/Footer';
import Login from './components/auth/Login';
import Consent from './components/auth/Consent';
import Dashboard from './components/views/Dashboard';
import DocumentViewPage from './components/views/DocumentViewPage';
import ThankYou from './components/views/ThankYou';
import PreExperiment from './components/experiment/PreExperiment';
import PostExperiment from './components/experiment/PostExperiment';
import WebsitePage from './components/experiment/WebsitePage';
import DocumentationIntro from './components/experiment/DocumentationIntro';
import PlatformTutorial from './components/experiment/PlatformTutorial';
import DocumentationReview from './components/experiment/DocumentationReview';
import WebsiteExperimentEntry from './components/experiment/WebsiteExperimentEntry';
import ThreatModelViewerPage1 from './components/experiment/ThreatModelViewerPage1';
import ThreatModelViewerPage2 from './components/experiment/ThreatModelViewerPage2';
import AdminPage from './components/admin/AdminPage';

function App() {
  return (
    <Router>
      <div className="app-wrapper">
        <NavBar />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/admin/*" element={<AdminPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/consent" element={<Consent />} />
            <Route path="/pre-experiment" element={<PreExperiment />} />
            <Route path="/post-experiment" element={<PostExperiment />} />
            { /* Route replaced by Design Document Review step — commented out for now */ }
            { /* <Route path="/threat-model-learning" element={<ThreatModelLearning />} /> */ }
            <Route path="/documentation-intro" element={<DocumentationIntro />} />
            <Route path="/platform-tutorial" element={<PlatformTutorial />} />
            <Route path="/documentation-review" element={<DocumentationReview />} />
            <Route path="/experiment" element={<WebsiteExperimentEntry />} />
            <Route path="/document-view/:website_id" element={<DocumentViewPage />} />
            <Route path="/website1" element={<WebsitePage order_index={1} route_name='WEBSITE1' next_route_name='POST_EXPERIMENT' next_navigation='/post-experiment' />} />
            { /* Website2 temporarily disabled — keep route here for easy re-enable later */ }
            { /* <Route path="/website2" element={<WebsitePage order_index={2} route_name='WEBSITE2' next_route_name='POST_EXPERIMENT' next_navigation='/post-experiment' />} /> */ }
            <Route path="/threatmodelviewer-page1" element={<ThreatModelViewerPage1 />} />
            <Route path="/threatmodelviewer-page2" element={<ThreatModelViewerPage2 />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
